import { useFormContext } from 'react-hook-form';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Import marker images
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Set default icon paths
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow
});

const Map = () => {
  const { getValues } = useFormContext();
  const formValues = getValues();

  const position = {
    lat: formValues.lat,
    lng: formValues.lng
  };

  return (
    <div className="h-[400px] rounded overflow-hidden border">
      <MapContainer center={position} zoom={13} className="h-full">
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <LocationMarker />
      </MapContainer>
    </div>
  );
};

const LocationMarker = () => {
  const { setValue, watch } = useFormContext();

  useMapEvents({
    click(e) {
      setValue('lat', e.latlng.lat);
      setValue('lng', e.latlng.lng);
    }
  });

  const position = {
    lat: watch('lat'),
    lng: watch('lng')
  };

  return position.lat && position.lng ? <Marker position={position} /> : null;
};

export default Map;
